import { useMutation } from '@apollo/client'
import { Button, CircularProgress, Divider } from '@material-ui/core'
import { useState } from 'react'
import { toast } from 'react-toastify'

import { addJob } from '../../cache/jobs'
import PageHeader from '../../components/PageHeader'
import {
  RESET_CHANNEL_INVENTORY_MUTATION,
  RESET_CRS_INVENTORY_MUTATION
} from '../../graphql/Inventory'
import { getTodayDate } from '../../helpers/date'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { JobsType } from '../../mockData/jobs'
import inventoryPagesRoleManagement from '../../staticRoleManagement/inventoryRoleManagement'
import { ResetInventoryInput } from '../../types/inventory'
import InventoryBasicFilters from './InventoryBasicFilters'
import useStyles from './styles/InventoryBulkUpdate.style'

function Index() {
  const classes = useStyles()

  const hasAccessToChangeTenant = inventoryPagesRoleManagement
    .find((item) => item.route === '/inventory/:page')
    ?.sections?.SELECT_TENANT.rolesListWithWriteAccess?.includes(
      getRoleFromStorage()
    )
  const hasAccessToChangeAccommodation = inventoryPagesRoleManagement
    .find((item) => item.route === '/inventory/:page')
    ?.sections?.SELECT_ACCOMMODATION.rolesListWithWriteAccess?.includes(
      getRoleFromStorage()
    )

  const hasAccessToBulkReset = inventoryPagesRoleManagement
    .find((item) => item.route === '/inventory/:page')
    ?.tabs?.find((tabItem) => tabItem.params.page === 'bulk-reset')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())
  const isChannel = inventoryPagesRoleManagement
    .find((item) => item.route === '/inventory/:page')
    ?.sections?.IS_CHANNEL.rolesListWithWriteAccess?.includes(
      getRoleFromStorage()
    )
  const [isChannelSelected, setisChannelSelected] = useState<boolean>(
    isChannel || false
  )

  const [input, setinput] = useState<ResetInventoryInput>({
    endDate: '',
    startDate: '',
    propertyCode: '',
    providerCode: ''
  })
  const [resetCRSInventory, { loading: loadingForCRSInventory }] = useMutation(
    RESET_CRS_INVENTORY_MUTATION,
    {
      onCompleted: (resp) => {
        if (resp.resetCRSInventory.trackingID) {
          const newJob: JobsType = {
            trackID: resp.resetCRSInventory.trackingID,
            creationDate: getTodayDate(),
            status: 'InProgress'
          }
          addJob(newJob)
          toast.info(getTranslate('reset CRS inventory started'))
        } else {
          throw new Error(getTranslate('Server error, please try again'))
        }
      },
      onError: (err) => {
        toast.error(err.message)
      }
    }
  )
  const [resetChannelInventory, { loading: loadingForChannelInventory }] =
    useMutation(RESET_CHANNEL_INVENTORY_MUTATION, {
      onCompleted: (resp) => {
        if (resp.resetChannelInventory.trackingID) {
          const newJob: JobsType = {
            trackID: resp.resetChannelInventory.trackingID,
            creationDate: getTodayDate(),
            status: 'InProgress'
          }
          addJob(newJob)
          toast.info(getTranslate('reset Channel inventory started'))
        } else {
          throw new Error(getTranslate('Server error, please try again'))
        }
      },
      onError: (err) => {
        toast.error(err.message)
      }
    })

  return (
    <div className={classes.root}>
      <PageHeader title={getTranslate('Bulk Reset')} />
      <InventoryBasicFilters
        {...{
          hasAccessToChangeTenant: !!hasAccessToChangeTenant,
          hasAccessToChangeAccommodation: !!hasAccessToChangeAccommodation,
          isChannelSelected,
          setisChannelSelected,
          input,
          setinput
        }}
      />
      <Divider className={classes.DividerLine} />
      <div className={classes.confirmButtonContainer}>
        <Button
          disabled={
            !hasAccessToBulkReset ||
            loadingForCRSInventory ||
            loadingForChannelInventory ||
            !!!input.propertyCode ||
            !!!input.providerCode ||
            !!!input.startDate ||
            !!!input.endDate ||
            (!!!input.channelID && isChannelSelected) //)
          }
          variant="contained"
          color="primary"
          onClick={() => {
            if (input.channelID && isChannelSelected) {
              resetChannelInventory({
                variables: {
                  input: input
                }
              })
            } else {
              const { channelID, ...newInput } = input
              resetCRSInventory({
                variables: {
                  input: newInput
                }
              })
            }
          }}>
          {getTranslate('Confirm')}
          {loadingForCRSInventory ||
            (loadingForChannelInventory && (
              <CircularProgress
                className={classes.circularProgress}
                size={16}
                color="primary"
              />
            ))}
        </Button>
      </div>
    </div>
  )
}

export default Index
